import { render } from "./OTPInvitationPage.vue?vue&type=template&id=1643b9e0&ts=true"
import script from "./OTPInvitationPage.vue?vue&type=script&lang=ts"
export * from "./OTPInvitationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/OTPInvitationPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1643b9e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1643b9e0', __exports__)) {
    api.reload('1643b9e0', __exports__)
  }
  
  module.hot.accept("./OTPInvitationPage.vue?vue&type=template&id=1643b9e0&ts=true", () => {
    api.rerender('1643b9e0', render)
  })

}


export default __exports__